import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import ShiftRepository from "../../repositories/ShiftRepository";
import SearchResultEntity from "../../entities/SearchResultEntity";
import ShiftEntity from "../../entities/ShiftEntity";

interface _Props {
    shiftRepository: ShiftRepository;
}

@injectable()
export default class SearchShiftsUseCase {
    private shiftRepository: ShiftRepository;
    
    constructor(props: _Props) {
        this.shiftRepository = props.shiftRepository;
    }
    
    public call = async (query: string | undefined, page: number, itemsPerPage: number) : Promise<Either<ErrorEntity, SearchResultEntity<ShiftEntity>>> => {
        return this.shiftRepository.searchShifts(query, page, itemsPerPage);
    }
}

export const SearchShiftsUseCaseName = "SearchShiftsUseCase";